import {
  Box,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Text,
  Tooltip,
  Badge,
  useColorModeValue,
  IconButton,
  useClipboard
} from "@chakra-ui/react";
import {
  MdBlockFlipped,
  MdContentCopy
} from "react-icons/md";
import Card from "components/card/Card.js";
import React from "react";

export default function ProductCard({product}) {
    const sellerProduct = product;
    const textColor = useColorModeValue("navy.700", "white");
    const { hasCopied, onCopy } = useClipboard(product.prod_code);
    
  return (
    <Card p="20px" bg="#F3F0FFA0">
      <Flex direction={{ base: "column" }} justify="center">
            
        <Box mb={{ base: "20px", "2xl": "20px" }} position="relative" backgroundColor="white" borderRadius="20px"  >
          <Image
            src={sellerProduct.image_link}
            w="500px"
            h="300px"
            borderRadius="20px"
            fit="contain"
          />
          <Button
            position="absolute"
            bg="transparent"
            // bg="white"
            p="0px !important"
            top="-7px"
            right="0px"
            borderRadius="50%"
          >
            {/* <Tooltip
              label={
                sellerProduct.status === "TC" ? "Official Seller"
                : sellerProduct.status === "TD" ? "Counterfeit Seller for this user"
                : sellerProduct.status === "T" ? "Counterfeit Seller for this user"
                : sellerProduct.status === "R" ? "Counterfeit Seller for this user"
                : "Suspicious Seller"
              }
            > */}
            <Text color={textColor} fontSize="30px">
              {sellerProduct.status === "TD" ? (
                <Badge variant="solid" colorScheme="red">
                  Taken Down
                </Badge>
              ) : sellerProduct.status === "R" ? (
                <Badge variant="subtle" colorScheme="red">
                  Reported
                </Badge>
              ) : sellerProduct.status === "S" ? (
                <Badge variant="subtle" colorScheme="yellow">
                  Suspicious
                </Badge>
              ) : sellerProduct.status === "W" ? (
                <Badge variant="subtle" colorScheme="green">
                  WhiteList
                </Badge>
              ) : (
                <Icon color="gold" as={MdBlockFlipped} />
              )}
            </Text>
            {/* </Tooltip> */}
          </Button>
        </Box>
        <Flex flexDirection="column" justify="space-between" h="100%">
          <Flex
            justify="space-between"
            direction={{
              base: "row",
              md: "column",
              lg: "row",
              xl: "column",
              "2xl": "row",
            }}
            mb="auto"
          >
            <Flex direction="column">
              <Text
                color={textColor}
                fontSize={{
                  base: "xl",
                  md: "lg",
                  lg: "lg",
                  xl: "lg",
                  "2xl": "md",
                  "3xl": "lg",
                }}
                mb="5px"
                fontWeight="bold"
                me="14px"
              >
                <Link
                  textDecoration="underline"
                  href={sellerProduct.prod_link}
                  isExternal
                >
                  <Tooltip label={sellerProduct.title} placement="top" hasArrow>
                    <Text isTruncated>{sellerProduct.title}</Text>
                  </Tooltip>
                </Link>
              </Text>
              <Text
                color="secondaryGray.900"
                fontSize={{
                  base: "sm",
                }}
                align="right"
                fontWeight="400"
                me="14px"
              >
                Keyword: {sellerProduct.keyword}
              </Text>

              <Text fontWeight="600" fontSize="sm" color={textColor}>
                Code: {sellerProduct.prod_code}
                <Tooltip label={hasCopied ? "Copied!" : "Copy to Clipboard"}>
                  <IconButton
                    aria-label="Copy to Clipboard"
                    icon={<MdContentCopy />}
                    onClick={onCopy}
                    variant="ghost"
                    colorScheme={hasCopied ? "green" : "gray"}
                    height="17px"
                  />
                </Tooltip>
              </Text>
              <Text fontWeight="500" fontSize="md" color={textColor}>
                Selling Price: ₹ {sellerProduct.selling_price}
              </Text>
              <Text fontWeight="500" fontSize="md" color={textColor}>
                MRP: ₹ {sellerProduct.mrp}
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
